// extracted by mini-css-extract-plugin
export var actionButton = "_73-0";
export var attachmentLine = "_73-1";
export var fileInput = "_73-2";
export var fileUploadWrapper = "_73-4";
export var footer = "_73-3";
export var modalContent = "_73-5";
export var paperclip = "_73-6";
export var quillEditor = "_73-7";